import React, { Component } from "react";
import axios from "axios";
import CheckboxTheme from "css/themes/Checkbox.css";
import FullscreenModalTheme from "css/themes/modals/FullscreenModalTheme.css";
import Theme from "css/themes/payments/upgrade-plan-full-modal.css";
import BrowserHistoryDispatcher from "dispatchers/browser-history-dispatcher";
import CardDispatcher from "dispatchers/card-dispatcher";
import CurrentBrandDispatcher from "dispatchers/current-brand-dispatcher";
import moment from "moment";
import { object } from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Checkbox } from "react-toolbox/lib/checkbox";
import {
  beltMapping,
  cleanPlanText,
  getLTCPlans,
  getPlanLabel,
  isTrialing,
} from "util/brand-stripe-belt-helper";
import Spinner from "util/components/spinner";
import ModalButtonGroupWithContext from "visual-components/util/buttons/ModalButtonGroupWithContext";
import ChooseCard from "visual-components/util/choose-card";
import { Select, SimpleForm } from "visual-components/util/form";
import FullscreenModal from "visual-components/util/modals/FullscreenModal";
import { H3, H4, H6, P } from "visual-components/util/texts";
import OrderSummaryDisplay from "./order-summary-display";
import { applyPlanPromos, applySummaryPromos } from "./subscription-promotions";

const mapStateToProps = (state) => ({
  customer: state.customer,
  currentBrand: state.currentBrand,
  invoices: state.invoices,
  card: state.card,
});

let defaultPlans = [
  {
    value: "solo",
    label: "Solo - $9.95/mo (billed monthly)",
  },
  {
    value: "solo-annual",
    label: "Solo - $89.95/yr (billed annually, save 25%)",
  },
  {
    value: "greenFixed",
    label: "Essential - $199/mo (billed monthly)",
  },
  {
    value: "black",
    label: "Premium - $499/mo (billed monthly)",
  },
];

const defaultSummaryMap = {
  solo: {
    plan: "Solo Plan (billed monthly)",
    planAmount: 9.95,
    featureSet: "solo",
  },

  "solo-annual": {
    plan: "Solo Plan (billed annually)",
    planAmount: 89.95,
    featureSet: "solo",
  },

  greenFixed: {
    plan: "Essential Plan (billed monthly)",
    planAmount: 199,
    featureSet: "essential",
  },

  black: {
    plan: "Premium Plan (billed monthly)",
    planAmount: 499,
    featureSet: "premium",
  },
};

class UpgradePlanFullModal extends Component {
  static propTypes = {
    currentBrand: object.isRequired,
    customer: object.isRequired,
    invoices: object.isRequired,
    card: object.isRequired,
    location: object.isRequired,
    match: object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      agreementChecked: false,
      promoCode: "",
      promoValid: false,
      promoError: "",
      promoDiscount: 0,
      appliedPromoId: null,
    };
  }

  componentDidMount() {
    const {
      currentBrand,
      location,
      match: {
        params: { belt },
      },
    } = this.props;

    const isMissingPayment = location.pathname.includes("missing-payment");
    this.setState({
      selectedPlan: isMissingPayment ? currentBrand.stripe_belt : belt,
      orderSummary: applySummaryPromos(defaultSummaryMap, currentBrand.stripe_belt)[
        isMissingPayment ? currentBrand.belt : belt
      ],
    });
  }

  back = () => BrowserHistoryDispatcher.goBack();

  toggleAgreement = () => {
    this.setState((prevState) => ({ agreementChecked: !prevState.agreementChecked }));
  };

  onUpdate = ({ selectedPlan }) => {
    if (!selectedPlan) return;

    this.setState({
      selectedPlan,
      orderSummary: applySummaryPromos(defaultSummaryMap, this.props.currentBrand.stripe_belt)[
        selectedPlan
      ],
    });
  };

  onSubmit = async () => {
    const {
      currentBrand,
      match: {
        params: { belt },
      },
      location,
    } = this.props;

    const { selectedPlan, appliedPromoId } = this.state;

    const isMissingPayment = location.pathname.includes("missing-payment");

    await CardDispatcher.updateBilling(true);

    if (isMissingPayment) {
      CurrentBrandDispatcher.updateCreditCard(currentBrand.stripe_belt);
    } else {
      CurrentBrandDispatcher.upgradeConfirm(
        selectedPlan || belt,
        currentBrand.isNY,
        appliedPromoId,
      );
    }
  };

  handleApplyPromo = async () => {
    const { promoCode } = this.state;
    if (!promoCode) {
      this.setState({ promoError: "Please enter a promo code." });
      return;
    }

    try {
      // Call your backend route to validate Stripe promo
      const { data } = await axios.post("/validate-promo", { code: promoCode });

      if (data.valid) {
        this.setState({
          promoValid: true,
          promoError: "",
          promoDiscount: data.promotionCode.coupon?.amount_off,
          appliedPromoId: data.promotionCode.coupon?.id,
        });
      } else {
        this.setState({
          promoError: "Invalid or expired promo code.",
          promoValid: false,
        });
      }
    } catch (err) {
      this.setState({
        promoError: err.response?.data?.error || "Unable to validate promo code",
        promoValid: false,
      });
    }
  };

  render() {
    const { currentBrand, customer, invoices, card, location } = this.props;

    const { selectedPlan, orderSummary, agreementChecked } = this.state;
    const { selectedSource, creditCards = [] } = customer;
    if (!currentBrand.id) return <Redirect to="/" />;

    const subscription =
      customer &&
      customer.subscriptions &&
      customer.subscriptions.data &&
      customer.subscriptions.data.length
        ? customer.subscriptions.data[0]
        : null;
    const trialing = isTrialing(currentBrand, customer);
    const isTrialConfirm = location.pathname.includes("upgrade-trial-confirm");
    const isMissingPayment = location.pathname.includes("missing-payment");
    const isCurrentB3G1 =
      currentBrand.stripe_belt && currentBrand.stripe_belt.includes("buy3-get1");

    if (currentBrand.stripe_belt === "essential-12months-upfront")
      defaultPlans = defaultPlans.filter((plan) => plan.value !== "greenFixed");
    if (currentBrand.stripe_belt === "premium-12month-upfront")
      defaultPlans = defaultPlans.filter((plan) => plan.value !== "black");

    // TODO: Eventually remove these 3?
    if (currentBrand.stripe_belt === "premium-buy3-get1-upfront")
      defaultPlans = defaultPlans.filter((plan) => plan.value !== "essential-12months-upfront");
    if (currentBrand.stripe_belt === "pro-12month-upfront")
      defaultPlans = defaultPlans.filter((plan) => plan.value !== "pro");
    if (currentBrand.stripe_belt === "pro-buy3-get1-upfront")
      defaultPlans = defaultPlans.filter((plan) => plan.value !== "premium-12month-upfront");

    if (isCurrentB3G1) defaultPlans = defaultPlans.filter((plan) => plan.value.includes("12month"));

    let plans = applyPlanPromos(defaultPlans, currentBrand.stripe_belt);
    const summaryMap = applySummaryPromos(defaultSummaryMap, currentBrand.stripe_belt);

    if (isTrialConfirm) {
      plans = plans.filter((plan) => !plan.upgradeOnly);
    }

    const currentPlan = plans.findIndex((plan) => plan.value === currentBrand.stripe_belt);
    const upgradePlans = [
      {
        label: "Select which plan to upgrade to",
        value: "",
        disabled: true,
      },
    ].concat(!subscription || trialing || currentPlan < 0 ? plans : plans.slice(currentPlan + 1));

    const canSave = !!selectedPlan && (isTrialConfirm || (agreementChecked && !!selectedSource));

    // Figure out if user is adding new card or using saved card
    // Then lookup the right place for the NY Tax info
    const selectedCardDetails = creditCards.find((c) => c.id === selectedSource) || {};
    const lookupLocation = card.adding ? currentBrand : selectedCardDetails;

    let preferredTermsPlan;
    let preferredTermsSummary;
    if (currentBrand.pendingPreferredTermsPlan) {
      const { plan_id, plan_label, plan_cost, discount_label, discount_amount } =
        currentBrand.pendingPreferredTermsPlan;
      const isPremium = cleanPlanText(plan_id) === "black";
      const isPro = cleanPlanText(plan_id) === "pro";
      preferredTermsPlan = [
        {
          label: plan_label,
          value: plan_id,
        },
      ];
      preferredTermsSummary = {
        plan: plan_label,
        planAmount: plan_cost,
        discountAmount: discount_amount,
        discountLabel: discount_label,
        featureSet: isPro ? "pro" : isPremium ? "premium" : "essential",
      };
    }

    let missingPaymentPlan;
    let missingPaymentSummary;
    if (isMissingPayment) {
      const isPremium = cleanPlanText(currentBrand.stripe_belt) === "black";
      const isPro = cleanPlanText(currentBrand.stripe_belt) === "pro";
      const planConfig = beltMapping[currentBrand.stripe_belt];
      const intervalMap = {
        monthly: 1,
        quarterly: 3,
        "bi-annually": 6,
        annually: 12,
      };
      const planCost =
        (isPro ? 899 : isPremium ? 499 : 199) *
        (intervalMap[planConfig.interval] || planConfig.count);
      missingPaymentPlan = [
        {
          label: getPlanLabel(currentBrand.stripe_belt),
          value: currentBrand.stripe_belt,
        },
      ];
      missingPaymentSummary = {
        plan: getPlanLabel(currentBrand.stripe_belt),
        planAmount: planCost,
        featureSet: isPro ? "pro" : isPremium ? "premium" : "essential",
        ...((currentBrand.stripe_belt.includes(12) || currentBrand.stripe_belt.includes(6)) && {
          discountAmount: planCost * (currentBrand.stripe_belt.includes(12) ? 0.25 : 0.1),
          discountLabel: currentBrand.stripe_belt.includes(12)
            ? "Annual Discount (25%)"
            : "Bi-annual Discount (10%)",
        }),
      };
    }

    const isCurrentlyOnLTC = getLTCPlans()
      .map(([value]) => value)
      .includes(currentBrand.stripe_belt);

    const billingChargedCopy = trialing
      ? `on your trial end date (${moment(currentBrand.trial_end).format("M/D/YYYY")})`
      : isCurrentlyOnLTC && !isMissingPayment
        ? `at the end of your current plan term${currentBrand.renewalDate ? ` (${moment(currentBrand.renewalDate).format("M/D/YYYY")})` : ""}`
        : "today";

    const paymentInterval = selectedPlan && beltMapping[selectedPlan].interval;
    const renewalInterval =
      selectedPlan &&
      (selectedPlan.includes(12)
        ? "annually"
        : selectedPlan.includes(6)
          ? "bi-annually"
          : "monthly");

    const confirmationCopy = `Your account will be charged ${billingChargedCopy}${renewalInterval !== "monthly" ? `. Your plan will be charged ${paymentInterval !== renewalInterval ? paymentInterval : "upfront"}` : ""} and your subscription will automatically renew ${renewalInterval}.`;

    const orderSummaryObj = preferredTermsSummary || missingPaymentSummary || orderSummary || {};
    const orderObj = { ...orderSummaryObj };

    if (this.state.promoValid) {
      orderObj.discountAmount = this.state.promoDiscount / 100;
      orderObj.discountLabel = `Applied code: (${this.state.promoCode})`;
    }

    orderObj.extraItem = null;
    orderObj.extraCost = 0;

    return (
      <div>
        {(customer.loading || card?.loading) && <Spinner needsBackground />}
        <FullscreenModal
          title={
            isMissingPayment ? "Confirm Payment Method to Continue" : "Confirm Upgrade Details"
          }
          close={isMissingPayment ? null : this.back}
        >
          <SimpleForm model={this.state} updateModel={this.onUpdate} handleSubmit={this.onSubmit}>
            <div className={Theme.mainContainer}>
              <div className={Theme.reviewItems}>
                <div className={Theme.reviewItems__header}>
                  <H3 coral>
                    <small>{isMissingPayment ? "Subscription" : "Review Items"}</small>
                  </H3>
                </div>

                {isMissingPayment ? (
                  <P multiline>
                    Please update your billing to keep using DojoMojo’s most powerful features.
                  </P>
                ) : null}

                <div className={Theme.reviewItems__subsection}>
                  <div className={Theme.reviewItems__subsection__header}>
                    <H6>Brand</H6>
                  </div>
                  <div className={Theme.reviewItems__subsection__brandDisplay}>
                    <div className={Theme.reviewItems__subsection__brandName}>
                      <P>{currentBrand.accountname}</P>
                    </div>
                  </div>
                </div>

                {isMissingPayment ? (
                  <div className={Theme.reviewItems__subsection}>
                    <div className={Theme.reviewItems__subsection__header}>
                      <H6>Your Subscription</H6>
                    </div>
                    <div className={Theme.reviewItems__subsection__brandDisplay}>
                      <div className={Theme.reviewItems__subsection__brandName}>
                        <P>
                          {summaryMap[currentBrand.stripe_belt]
                            ? summaryMap[currentBrand.stripe_belt].simplePlan
                            : getPlanLabel(currentBrand.stripe_belt)}
                        </P>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className={Theme.reviewItems__subsection}>
                    <Select
                      name="selectedPlan"
                      label={isTrialConfirm ? "Trial plan" : "Upgrade to"}
                      options={preferredTermsPlan || missingPaymentPlan || upgradePlans}
                      required
                    />
                  </div>
                )}
                {isTrialConfirm ? (
                  <H4>
                    <i>No Payment Info Required</i>
                  </H4>
                ) : (
                  <div>
                    <div>
                      <H3 coral>
                        <small>Payment Information</small>
                      </H3>
                    </div>

                    <div className={Theme.choosePaymentMethod}>
                      <ChooseCard />
                    </div>

                    <div className={Theme.reviewItems__subsection}>
                      <div className={Theme.reviewItems__subsection__header}>
                        <H6>Promo Code</H6>
                      </div>
                      <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                        <input
                          type="text"
                          value={this.state.promoCode}
                          placeholder="Enter promo code"
                          onChange={(e) =>
                            this.setState({
                              promoCode: e.target.value,
                              promoError: "",
                              promoValid: false,
                            })
                          }
                          style={{
                            padding: "8px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            flex: 1,
                          }}
                          disabled={this.state.promoValid}
                        />
                        <button
                          type="button"
                          onClick={this.handleApplyPromo}
                          style={{
                            padding: "8px 16px",
                            backgroundColor: "#ff6600",
                            color: "#fff",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                          disabled={this.state.promoValid}
                        >
                          {this.state.promoValid ? "Applied" : "Apply"}
                        </button>
                      </div>
                      {this.state.promoError && (
                        <P style={{ color: "red", marginTop: "6px" }}>{this.state.promoError}</P>
                      )}
                      {this.state.promoValid && (
                        <P style={{ color: "green", marginTop: "6px" }}>
                          ✅ Promo applied! ${this.state.promoDiscount / 100} off
                        </P>
                      )}
                    </div>

                    <div className={Theme.agreement__checkbox}>
                      <Checkbox
                        onChange={this.toggleAgreement}
                        checked={agreementChecked}
                        theme={CheckboxTheme}
                      />

                      <div className={Theme.agreement__terms}>
                        <P style={{ lineHeight: "22px" }}>
                          <em>
                            {`${confirmationCopy} Note that customers based in New York will be charged sales tax. You can cancel anytime by emailing `}
                          </em>
                          <a href="hello:hello@dojomojo.com">hello@dojomojo.com</a>
                          <em>.</em>
                        </P>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <OrderSummaryDisplay
                type="upgrade"
                upgradeOrderSummary={orderObj}
                chargeTax={lookupLocation.isNY}
                rate={lookupLocation.taxRate}
              />
            </div>

            <div className={FullscreenModalTheme.buttonGroupFixedBottom}>
              <ModalButtonGroupWithContext
                cancel={isMissingPayment ? null : this.back}
                cancelText="Back"
                confirmText={
                  isTrialConfirm
                    ? "Start 30 Day Free Trial"
                    : isMissingPayment
                      ? "Submit Payment"
                      : "Upgrade Now"
                }
                canSave={canSave}
                hideLine
              />
            </div>
          </SimpleForm>
        </FullscreenModal>
      </div>
    );
  }
}

export default connect(mapStateToProps)(UpgradePlanFullModal);
